import React, { useEffect, useState } from 'react';
import { ColorPicker } from 'primereact/colorpicker';
import { Swiper, SwiperSlide } from 'swiper/react';
import { fetchCroppedImage } from '@/utils/constants';
import ImageCropper from '@/components/imageCropper/imageCropper';
import { postData } from '@/services/api.service';
import { toast } from 'react-toastify';
import { Navigation } from 'swiper/modules';
import { ImageType } from '@/services/openai.service';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import {
  priorityicon1,
  priorityicon10,
  priorityicon11,
  priorityicon12,
  priorityicon13,
  priorityicon14,
  priorityicon15,
  priorityicon16,
  priorityicon17,
  priorityicon2,
  priorityicon3,
  priorityicon4,
  priorityicon5,
  priorityicon6,
  priorityicon7,
  priorityicon8,
  priorityicon9,
} from '@/utils/imagepath';

const LaundryEditModal = ({ themeData, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');

  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [iconImages, setIconImages] = useState<string[]>([]);

  const icons = [
    priorityicon1,
    priorityicon2,
    priorityicon3,
    priorityicon4,
    priorityicon5,
    priorityicon6,
    priorityicon7,
    priorityicon8,
    priorityicon9,
    priorityicon10,
    priorityicon11,
    priorityicon12,
    priorityicon13,
    priorityicon14,
    priorityicon15,
    priorityicon16,
    priorityicon17,
  ];

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  const handleImageChange = (image: string, index: any) => {
    const updatedCollection = [
      ...editData.theme_3.home.section_3.card_section.collection,
    ];
    updatedCollection[index] = {
      ...updatedCollection[index],
      icon: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_3: {
            ...prevJsonData.theme_3.home.section_3,
            card_section: {
              ...prevJsonData.theme_3.home.section_3.card_section,
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink, activeTab);
    }
  };
  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };
  const handleChange = (e: any, index?: any) => {
    const { value, name, type, checked } = e.target;
    let updatedCollection: any = [
      ...editData.theme_3.home.section_3.card_section.collection,
    ];
    if (index != undefined) {
      updatedCollection = [
        ...editData.theme_3.home.section_3.card_section.collection,
      ];
      updatedCollection[index] = {
        ...updatedCollection[index],
        [name]: value,
      };
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_3: {
            ...prevJsonData.theme_3.home.section_3,
            [name]: value,
            card_section: {
              btn_group: {
                ...prevJsonData.theme_3.home.section_3.card_section.btn_group,
                btn1: {
                  ...prevJsonData.theme_3.home.section_3.card_section.btn_group
                    .btn1,
                  text:
                    name === 'btn1.text'
                      ? value
                      : prevJsonData.theme_3.home.section_3.card_section
                          .btn_group.btn1.text,
                  bg_color:
                    name === 'bg_color'
                      ? value
                      : prevJsonData.theme_3.home.section_3.card_section
                          .btn_group.btn1.bg_color,
                  color:
                    name === 'color'
                      ? value
                      : prevJsonData.theme_3.home.section_3.card_section
                          .btn_group.btn1.color,
                },
              },
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const removeCollection = (index: any) => {
    let updatedCollection: any = [
      ...editData.home.section_3.card_section.collection,
    ];
    updatedCollection.splice(index, 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_3: {
            ...prevJsonData.theme_3.home.section_3,
            card_section: {
              btn_group: {
                ...prevJsonData.theme_3.home.section_3.card_section.btn_group,
              },
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const addCollection = () => {
    let updatedCollection: any = [
      ...editData.theme_3.home.section_3.card_section.collection,
    ];

    let newCard = {
      icon: 'assets/icons/priorityicon1.png',
      collection_title: '',
      collection_paragraph: '',
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_3: {
            ...prevJsonData.theme_3.home.section_3,
            card_section: {
              btn_group: {
                ...prevJsonData.theme_3.home.section_3.card_section.btn_group,
              },
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  // Auto-generate prompt based on current card context for icon
  const generateAutoPromptIcon = (): string => {
    // Get context from the current active card
    const currentCard = editData?.theme_3?.home?.section_3?.card_section?.collection?.[activeTab];
    const cardTitle = currentCard?.collection_title || '';
    const cardParagraph = currentCard?.collection_paragraph || '';
    const sectionTitle = editData?.theme_3?.home?.section_3?.title || '';
    const sectionParagraph = editData?.theme_3?.home?.section_3?.paragraph || '';
    
    // Build context-based prompt for icon
    let contextPrompt = 'modern minimalist icon design';
    
    if (cardTitle || cardParagraph || sectionTitle || sectionParagraph) {
      const contextParts: string[] = [];
      if (cardParagraph) {
        // Extract keywords from paragraph
        const keywords = cardParagraph.split(' ').slice(0, 3).join(' ');
      } else if (sectionParagraph) {
        const keywords = sectionParagraph.split(' ').slice(0, 3).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add icon-specific styling
    contextPrompt += ', clean modern minimalist icon, professional design, suitable for card icon, vibrant colors, high quality, simple and recognizable, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI icon save
  const handleAIIconSave = (iconUrl: string) => {
    // Auto-apply the icon to the current active card
    handleImageChange(iconUrl, activeTab);
    
    // Add to icons array for slider
    setIconImages(prevIcons => [...prevIcons, iconUrl]);
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load existing template images from Redux store
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template3';
      const currentTemplate = templateImages[templateKey];
      const iconImgs = currentTemplate?.icon || [];
      
      if (Array.isArray(iconImgs) && iconImgs.length > 0) {
        const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
              resolve({ url, width: img.width, height: img.height });
            };
            img.onerror = () => {
              resolve(null);
            };
            img.src = url;
          });
        };

        const filterImages = async () => {
          const imagePromises = iconImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          
          // Filter for square/icon images (aspect ratio 0.9-1.1)
          const squareImages = loadedImages
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          
          setIconImages(squareImages);
        };

        filterImages();
      } else {
        setIconImages([]);
      }
    } else {
      setIconImages([]);
    }
  }, [templateImages, template]);

  return (
    <>
      {/* <Draggable> */}
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section3 Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              {/* <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Sub Header</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="sub_heading_top"
                        value={
                          editData?.theme_3?.home?.section_3?.sub_heading_top
                        }
                        onChange={handleChange}
                        maxLength={250}
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={editData?.theme_3?.home?.section_3?.title}
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Description
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleChange({
                            target: {
                              name: 'paragraph',
                              value: content,
                            },
                          });
                        }}
                        contentType="website_description"
                        placeholder="Describe what you want in your description. Example: 'Write about our services, quality, and convenience'"
                        context="This is for a services section description"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      name="paragraph"
                      value={editData?.theme_3?.home?.section_3?.paragraph}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_3?.home?.section_3?.h2color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_3?.home?.section_3?.h2color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 2 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h3color"
                        value={editData?.theme_3?.home?.section_3?.h3color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h3color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_3?.home?.section_3?.h3color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_3?.home?.section_3?.paracolor}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_3?.home?.section_3?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_3?.home?.section_3?.card_section?.collection.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Card Section {index + 1}
                          </a>
                          <a
                            className="tab-close"
                            onClick={() => {
                              removeCollection(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_3?.home?.section_3?.card_section?.collection.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            <img
                              src={card.icon}
                              alt={`Card Icon ${index + 1}`}
                            />
                          </div>
                          <div className="img-options w-100">
                            {iconImages.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {iconImages.map((imageUrl: string, iconIndex: number) => (
                                  <SwiperSlide key={iconIndex}>
                                    <div
                                      className="img-option"
                                      onClick={() =>
                                        handleImageChange(imageUrl, index)
                                      }
                                    >
                                      <img
                                        src={imageUrl}
                                        alt="Icon Image"
                                        className="img-fluid"
                                      />
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Icons Available</h6>
                                  <p className="text-muted small mb-3">
                                    Generate AI icons or upload your own to see them here
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* AI Icon Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptIcon}
                        onSave={handleAIIconSave}
                        imageType="icon"
                        defaultWidth="128"
                        defaultHeight="128"
                        title="AI Icon"
                        autoGenerate={true}
                        template={template}
                      />

                      <div className="mb-3">
                        <label className="form-label">Upload Icon</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          className="form-control"
                          name="image"
                          onChange={updateImageSectionOne}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">
                          Title<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="collection_title"
                          value={card.collection_title}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                          <label className="form-label mb-0 mr-2">
                            Description
                          </label>
                          <AIContentWriter
                            onContentGenerated={(content) => {
                              handleChange({
                                target: {
                                  name: 'collection_paragraph',
                                  value: content,
                                },
                              }, index);
                            }}
                            contentType="product_description"
                            placeholder="Describe this service. Example: 'Write about professional washing service with quick turnaround'"
                            context="This is for a services section description 2 liner"
                          />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          name="collection_paragraph"
                          value={card.collection_paragraph}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={1200}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="add-section">
              <div className="row">
                <div
                  onClick={() => {
                    addCollection();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            {/* <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Button 1</label>
                    <input
                      type="text"
                      className="form-control"
                      name="btn1.text"
                      value={
                        editData?.theme_3?.home?.section_3?.card_section
                          ?.btn_group?.btn1?.text
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Bg Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="bg_color"
                        value={
                          editData?.theme_3?.home?.section_3?.card_section
                            ?.btn_group?.btn1?.bg_color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="bg_color"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        format="hex"
                        value={
                          editData?.theme_3?.home?.section_3?.card_section
                            ?.btn_group?.btn1?.bg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="color"
                        value={
                          editData?.theme_3?.home?.section_3?.card_section
                            ?.btn_group?.btn1?.color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="color"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        format="hex"
                        value={
                          editData?.theme_3?.home?.section_3?.card_section
                            ?.btn_group?.btn1?.color
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </Draggable> */}
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default LaundryEditModal;
